import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import styles from './styles.module.scss'

const FormRow = ({ children, className, ...props }) => {
  const renderChildren = () =>
    // IF characterWidth is applied
    // extend (Form)TextInput components so they don't flex
    // AND apply input width to container so input's alert & help text don't
    // extend outside of input's width
    React.Children.map(children, (child) => {
      if (
        React.isValidElement(child) &&
        (child.type.displayName === 'TextInput' ||
          child.type.displayName === 'TextInputWrapper' ||
          child.type.displayName === 'FormTextInput' ||
          child.type.displayName === 'Field')
      ) {
        return React.cloneElement(child, {
          style: {
            ...child.props.style,
            maxWidth: `${child.props.characterWidth + 4}ch`,
          },
          className: classNames(child.props.className, styles.formRowChild, {
            [styles.hasCharacterWidth]: child.props.characterWidth,
          }),
        })
      }
      return child
    })

  return (
    <div className={classNames(className, styles.formRow)} {...props}>
      {renderChildren()}
    </div>
  )
}

FormRow.displayName = 'FormRow'

FormRow.defaultProps = {
  className: null,
}

FormRow.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
}

export default FormRow
